<template>
    <div class="total-row">
        <div class="row">
            <div class="col-12 icon-col">
                <img class="total-icon" src="../../assets/img/outgoing-call.svg">
            </div>
            <div class="col-12 col-sm-12 col-lg-6 number-col">
                <div class="total-number-title text-uppercase text-muted card-title">Appointments</div>
                <div class="total-number total-number-small">{{this.chartData.appointments}}</div>
            </div>
            <div class="col-12 col-sm-12 col-lg-6 number-col">
                <div class="total-number-title text-uppercase text-muted card-title">Calls</div>
                <div class="total-number total-number-small">{{total}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            chartData: {
                type: Object,
                default: null
            }
        },
        computed: {
            total: function () {
                return this.numeral(this.chartData.total).format('0,0')
            },
            totalNumberClass: function () {
                return (this.chartData.total > 100000) ? 'total-number-small' : 'total-number-large'
            }
        }
    }
</script>
<style>
    .total-icon {
        height: 100px;
        color: #007bff;
    }

    .total-number-large {
        font-size: 80px;
        line-height: 60px;
    }

    .total-number-small {
        font-size: 55px;
        line-height: 35px;
    }

    .total-number-title {
        text-align: right;
    }

    .total-row {
        text-align: center;
    }

    .number-col {
        padding-top: 30px;
        padding-right: 25px;
        text-align: right;
    }

    .icon-col {
        padding-top: 20px;
    }
</style>
